// extracted by mini-css-extract-plugin
export default {"main":"About_main__Mjr12","buttons":"About_buttons__eIcDu","shape":"About_shape__OP7dn","shape2":"About_shape2__8Pi-v"};